// extracted by mini-css-extract-plugin
export default {"table_container":"CustomeTable_table_container__wNcsD","tableHeader":"CustomeTable_tableHeader__WlzL8","address":"CustomeTable_address__J2z-y"};